export default __webpack_public_path__ + "static/Plots0080-7be4b721fa85783e047fda4aaba868fc.jpg";